import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  providerAuthSettingsService,
  ProviderAuthSettingsRequestError,
} from '@/services/provider/provider-auth-settings.service';
import {
  ProviderAuthSettings,
  UpdateProviderAuthSettingsInput,
  CustomerAuthSettings,
  UpdateCustomerAuthSettingsInput,
} from '@/types/provider-auth-settings';

export const providerAuthSettingsKeys = {
  all: ['provider', 'auth-settings'] as const,
  detail: () => [...providerAuthSettingsKeys.all, 'detail'] as const,
  customerDetail: () => [...providerAuthSettingsKeys.all, 'customer-detail'] as const,
};

export function useProviderAuthSettings(enabled = true) {
  return useQuery<ProviderAuthSettings, ProviderAuthSettingsRequestError>({
    queryKey: providerAuthSettingsKeys.detail(),
    queryFn: () => providerAuthSettingsService.getAuthSettings(),
    enabled,
  });
}

export function useUpdateProviderAuthSettings() {
  const queryClient = useQueryClient();
  return useMutation<ProviderAuthSettings, Error, UpdateProviderAuthSettingsInput>({
    mutationFn: (input) => providerAuthSettingsService.updateAuthSettings(input),
    onSuccess: (data) => {
      queryClient.setQueryData(providerAuthSettingsKeys.detail(), data);
    },
  });
}

export function useCustomerAuthSettings(enabled = true) {
  return useQuery<CustomerAuthSettings, ProviderAuthSettingsRequestError>({
    queryKey: providerAuthSettingsKeys.customerDetail(),
    queryFn: () => providerAuthSettingsService.getCustomerAuthSettings(),
    enabled,
  });
}

export function useUpdateCustomerAuthSettings() {
  const queryClient = useQueryClient();
  return useMutation<CustomerAuthSettings, Error, UpdateCustomerAuthSettingsInput>({
    mutationFn: (input) => providerAuthSettingsService.updateCustomerAuthSettings(input),
    onSuccess: (data) => {
      queryClient.setQueryData(providerAuthSettingsKeys.customerDetail(), data);
    },
  });
}
